<template>
  <Teleport to="body">
    <Transition
      enter-active-class="transition-all duration-300 ease-out"
      enter-from-class="opacity-0 -translate-y-4"
      enter-to-class="opacity-100 translate-y-0"
      leave-active-class="transition-all duration-200 ease-in"
      leave-from-class="opacity-100 translate-y-0"
      leave-to-class="opacity-0 -translate-y-4"
    >
      <div
        v-if="showNotification"
        class="fixed top-[8vh] left-1/2 -translate-x-1/2 z-[99999] pointer-events-auto"
        role="alert"
      >
        <div
          class="bg-blue-900/60 border-2 border-cyan-400 rounded-lg shadow-2xl px-6 py-3 flex items-center gap-4 min-w-[320px] max-w-[600px] backdrop-blur-sm"
        >
          <!-- Icon -->
          <div class="flex-shrink-0">
            <Info :size="24" class="text-cyan-300" />
          </div>

          <!-- Message -->
          <div class="flex-1">
            <p class="text-white font-semibold text-sm">{{ text('ui.new_version_available') }}</p>
            <p class="text-cyan-200 text-xs">{{ text('ui.restart_to_update') }}</p>
            <p class="text-yellow-300 text-xs italic">{{ text('ui.may_experience_bugs') }}</p>
          </div>

          <!-- Restart Button -->
          <button
            @click="onRefresh"
            class="px-4 py-2 bg-cyan-500 hover:bg-cyan-400 text-white font-bold text-sm rounded transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-cyan-300 focus:ring-offset-2 focus:ring-offset-transparent"
          >
            {{ text('ui.restart') }}
          </button>

          <!-- Close Button -->
          <button
            @click="onDismiss"
            class="flex-shrink-0 text-cyan-300 hover:text-white transition-colors duration-200 focus:outline-none"
            :aria-label="text('ui.dismiss')"
          >
            <X :size="20" />
          </button>
        </div>
      </div>
    </Transition>
  </Teleport>
</template>

<script setup lang="ts">
import { Info, X } from 'lucide-vue-next';
import { ref } from 'vue';
import text from '~/text';

const showNotification = ref(false);

function onRefresh() {
  window.location.reload();
}

function onDismiss() {
  showNotification.value = false;
}

// Expose method to parent to show notification
defineExpose({
  show: () => {
    showNotification.value = true;
  },
  hide: () => {
    showNotification.value = false;
  },
});
</script>
